package com.tixforgigs.common.core.models.embed

import com.tixforgigs.apax.models.AuthToken
import kotlinx.serialization.Serializable

@OptIn(ExperimentalJsExport::class)
@Serializable
data class PostMessageEmbedAuthDTO(
  val authToken: AuthToken? = null,
  val oauthRedirectUrl: String? = null,
  val internalRedirectPath: String? = null
)
